<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            id="errorIconColor"
            d="M7.5 15.5C11.6421 15.5 15 12.1421 15 8C15 3.85786 11.6421 0.5
                7.5 0.5C3.35786 0.5 0 3.85786 0 8C0 12.1421 3.35786 15.5 7.5 15.5Z"
            fill="#DF5E51"
        />
        <path
            id="errorBackgroundColor"
            d="M7.47056 9.392C7.1999 9.392 7.01323 9.35933 6.91056 9.294C6.8079
                9.21933 6.75656 9.10266 6.75656 8.944V3.12C6.75656 2.82133 7.03656
                2.672 7.59656 2.672H8.19856C8.46923 2.672 8.67456 2.70466 8.81456
                2.77C8.9639 2.83533 9.03856 2.93333 9.03856 3.064L8.33856 8.944C8.3199
                9.10266 8.2639 9.21933 8.17056 9.294C8.07723 9.35933 7.89523 9.392
                7.62456 9.392H7.47056ZM7.31656 12.528C6.75656 12.528 6.47656 12.3787
                6.47656 12.08V10.792C6.47656 10.4933 6.75656 10.344 7.31656
                10.344H7.76456C8.32456 10.344 8.60456 10.4933 8.60456 10.792V12.08C8.60456
                12.3787 8.32456 12.528 7.76456 12.528H7.31656Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
  name: 'IconError',
};
</script>
